import { useCallback, useContext, useEffect, useState } from "react";

import { ApiHelper } from "@datanac/datanac-api-toolkit/dist/api-helper";
import { _sessionManager, UsersApiHelper } from "api/ApiHelper";
import { AppContext } from "App";
import { MODULE_ARC_PLC } from "components/Menu/config/constants";

import { isFarmPaymentCategory } from "./FarmPaymentConstants";

export default function useFarmPayments({ year }) {
  const { globalState } = useContext(AppContext);
  const [farmPayments, setFarmPayments] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchFarmPayments = useCallback(async () => {
    if (!globalState?.producer_token || !year) {
      setFarmPayments([]);
      setIsLoading(false);
      return;
    }

    setIsLoading(true);
    setError(null);

    try {
      const filter = {
        producer_token: globalState.producer_token,
        reinsurance_year: year,
        module: MODULE_ARC_PLC,
        is_active: true,
      };

      const result = await UsersApiHelper.users_search("InsurancePlanClaim", filter, globalState);
      setFarmPayments((result || []).filter((payment) => isFarmPaymentCategory(payment.payment_category)));
    } catch (err) {
      setError(err);
      setFarmPayments([]);
    } finally {
      setIsLoading(false);
    }
  }, [globalState, year]);

  useEffect(() => {
    fetchFarmPayments();
  }, [fetchFarmPayments]);

  const remove = useCallback(
    async (payment) => {
      if (!globalState?.producer_token) return;
      const api = new ApiHelper({
        baseUrl: import.meta.env.VITE_DATANAC_USERS_API_URL_BASE,
        config: {},
        sessionManager: _sessionManager,
        _instance: null,
      });

      await api.callPost(
        "InsurancePlanClaim",
        {
          module: MODULE_ARC_PLC,
          InsurancePlanClaim: [{ ...payment, is_active: false, module: MODULE_ARC_PLC }],
          producer_token: globalState.producer_token,
        },
        globalState
      );

      await fetchFarmPayments();
    },
    [fetchFarmPayments, globalState]
  );

  return {
    farmPayments,
    isLoading,
    error,
    refresh: fetchFarmPayments,
    remove,
  };
}
